import request from './request';

export function comment(id, type, data) {
    return request('post', `/apiv2/${type}/${id}/comment`, data);
}

export function commentReacted(id, type, data) {
    return request('post', `/apiv2/${type}/${id}/comment_reacted`, data);
}

export function comments(id, type, data) {
    return request('get', `/apiv2/${type}/${id}/comments`, data);
}

export function replies(id, data) {
    return request('get', `/apiv2/comment/${id}/replies`, data);
}

export function deleteComment(id) {
    return request('delete', `/apiv2/comment/${id}`);
}

export function updateComment(id, data) {
    return request('put', `/apiv2/comment/${id}/comment`, data);
}
